// extracted by mini-css-extract-plugin
export default {"professionIssuesChipContainer":"styles_professionIssuesChipContainer__JYoFT","flexContainer":"styles_flexContainer__+jEIW"};